module.exports = "https://s.pinimg.com/webapp/style/images/zhTW@2x-a58a93b3.png";